<ng-container *transloco="let t">
  <div class="empty-state-wrapper d-flex justify-content-center align-items-center p-4 p-md-5">
    <section class="d-flex flex-md-row flex-column align-items-center text-center">
      <p class="pe-2 fw-bold">{{t('emptyState.sorry')}}</p>
      <p class="">{{t('emptyState.not.able.to.find')}}</p>
    </section>
  </div>
</ng-container>
